import { TExportError, TExportFailure } from './exportErrors'

export type TExportState =
  | { status: 'idle' }
  | { status: 'running'; done: number; total: number }
  | { status: 'succeeded'; fileName: string; failures: TExportFailure[] }
  | { status: 'failed'; error: TExportError }

export type TExportAction =
  | { type: 'START'; total: number }
  | { type: 'PROGRESS' }
  | { type: 'SUCCESS'; fileName: string; failures: TExportFailure[] }
  | { type: 'FAILURE'; error: TExportError }

export const INITIAL_EXPORT_STATE: TExportState = { status: 'idle' }

export const exportReducer = (
  state: TExportState,
  action: TExportAction,
): TExportState => {
  switch (action.type) {
    case 'START':
      /* A second click while a run is in flight must not restart it. */
      return state.status === 'running'
        ? state
        : { status: 'running', done: 0, total: action.total }

    case 'PROGRESS':
      return state.status === 'running'
        ? { ...state, done: state.done + 1 }
        : state

    case 'SUCCESS':
      return {
        status: 'succeeded',
        fileName: action.fileName,
        failures: action.failures,
      }

    case 'FAILURE':
      return { status: 'failed', error: action.error }
  }
}
